import { createFileRoute, Link } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import MediaPlayer from "@/components/ui/media-player";
import { Button } from "@/components/ui/button";
import { socialNetworkSegments } from "@/lib/data/social-network";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/social-network/"
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "My Social Network - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "weakness.exercises.network",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const currentSegment = socialNetworkSegments[0];

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Link to="/adults/exercises/social-network/exercise">
          <Button className="w-full">
            <FormattedMessage
              id="breathing.startExercise"
              defaultMessage="Start Exercise"
            />
          </Button>
        </Link>
      }
    >
      <div className="space-y-1">
        <p className="text-small">
          <FormattedMessage id="network.intro" />
        </p>
        <p className="text-small">
          <FormattedMessage id="network.introGoalTitle" /> <br />
          <FormattedMessage id="network.introGoal" />
        </p>
      </div>
      <>
        <MediaPlayer
          src={currentSegment.audio}
          segment={currentSegment.segment}
        />
      </>
    </ExerciseLayout>
  );
}
